import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Row,
  Card,
  CardBody,
  CardHeader,
  Col,
  Spinner,
  Input,
  InputGroup,
  Button,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AwesomePagination from "../../../Components/Common/AwesomePagination";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";
import moment from "moment";
import FeatherIcon from "feather-icons-react";

const apiClient = new APIClient();

const Comissoes = ({ isCliente }) => {
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [termo, setTermo] = useState("");
  const [inputTermo, setInputTermo] = useState("");
  const [entregue, setEntregue] = useState("");
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const [comissoes, setComissoes] = useState([]);

  const user = JSON.parse(localStorage.getItem("authUser"));

  function formatName(name) {
    if (!name) return "";
    let lowerCaseName = name.toLowerCase();
    let properName = lowerCaseName.replace(
      /\b\w/g,
      function (letter, index, fullText) {
        const previousLetter = fullText[index - 1];
        const isWordAfterApostrophe = previousLetter === "'";
        if (isWordAfterApostrophe) {
          return letter;
        }
        const word = fullText.slice(index).match(/^\w+/)[0];
        const lowerCaseWords = ["de", "da", "do", "dos", "das"];
        if (lowerCaseWords.includes(word)) {
          return letter;
        }
        return letter.toUpperCase();
      }
    );

    // Converte a letra após um apóstrofo para maiúscula
    properName = properName.replace(/'\w/g, function (letter) {
      return letter.toUpperCase();
    });

    return properName;
  }

  const getComissoes = useCallback(async () => {
    setLoading(true);
    let data = {
      pagina: pagina,
      itens_pagina: 20,
      order_by: "created_at",
      order: "desc",
    };

    if (termo && termo !== "") {
      data.termo = termo;
    }

    if (entregue !== "" && entregue !== null) {
      data.entregue = entregue;
    }

    const response = await apiClient.post(`/comissao-indicacao/busca`, data);

    if (response.sucesso) {
      setComissoes(response.dados.data);
      setTotalPaginas(response.dados.last_page);
      setTotalItens(response.dados.total);
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  }, [pagina, termo, entregue]);

  const entregarComissao = useCallback(
    async (id) => {
      const response = await apiClient.post(`/comissao-indicacao/entregar/${id}`);
      if (response.sucesso) {
        toast.success(response.mensagem);
        setShouldFetch(true);
      } else {
        toast.error(response.mensagem);
      }
    },
    []
  );

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        await getComissoes();
        setShouldFetch(false);
      };
      fetchData();
    }
  }, [shouldFetch, getComissoes]);

  document.title = "Comissões | Painel Fort Exchange";

  const handleTermoKeyDown = (e) => {
    if (e.key === "Enter") {
      setTermo(inputTermo);
      setPagina(1);
      setShouldFetch(true);
    }
  };

  const handleEntregueChange = (e) => {
    setEntregue(e.target.value);
    setPagina(1);
    setShouldFetch(true);
  };

  const getStatusBadge = (entregue) => {
    return parseInt(entregue) === 0 ? (
      <Badge color="warning">Pendente</Badge>
    ) : (
      <Badge color="success">Entregue</Badge>
    );
  };

  const formatCurrency = (value) => {
    if (!value) return "-";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Comissões"
            pageTitle={isCliente ? "Clientes Fort" : "Aplicações"}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex align-items-center border-0">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {isCliente ? "Suas Comissões" : `Comissões (${totalItens})`}
                  </h5>
                </CardHeader>
                <CardBody>
                  {/* Filtros */}
                  <Row className="mb-3">
                    <Col md={9}>
                      <InputGroup>
                        <div className="input-group-text">
                          <FeatherIcon icon="search" className="icon-dual" />
                        </div>
                        <Input
                          type="text"
                          placeholder="Buscar por nome do cliente..."
                          value={inputTermo}
                          onChange={(e) => setInputTermo(e.target.value)}
                          onKeyDown={handleTermoKeyDown}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={3}>
                      <Input
                        type="select"
                        value={entregue}
                        onChange={handleEntregueChange}
                      >
                        <option value="">Todos os Status</option>
                        <option value="false">Pendente</option>
                        <option value="true">Entregue</option>
                      </Input>
                    </Col>
                  </Row>

                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        padding: "20px",
                      }}
                    >
                      <Spinner height={100} width={100} />
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>Data</th>
                              <th>Cliente</th>
                              <th>Valor</th>
                              <th>Status</th>
                              {!isCliente && <th>Ações</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {comissoes.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={isCliente ? 4 : 5}
                                  className="text-center text-muted py-4"
                                >
                                  Nenhuma comissão encontrada.
                                </td>
                              </tr>
                            ) : (
                              comissoes.map((item, idx) => (
                                <tr key={item.id || idx}>
                                  {/* Data */}
                                  <td>
                                    <b>
                                      {moment(item.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </b>
                                    <br />
                                    <small className="text-muted">
                                      {moment(item.created_at).format("HH:mm")}
                                    </small>
                                  </td>

                                  {/* Cliente */}
                                  <td>
                                    {item.user?.nome_completo ? (
                                      <div className="d-flex align-items-center">
                                        <Link
                                          to={`/clientes/${item.user_id}`}
                                          className="text-primary flex-grow-1"
                                        >
                                          <b>{formatName(item.user.nome_completo)}</b>
                                        </Link>
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  {/* Valor */}
                                  <td>
                                    <span className="fw-bold text-success">
                                      {formatCurrency(item.comissao_brl)}
                                    </span>
                                  </td>

                                  {/* Status */}
                                  <td>{getStatusBadge(item.entregue)}</td>

                                  {/* Ações - apenas para admin */}
                                  {!isCliente && (
                                    <td>
                                      {parseInt(item.entregue) === 0 ? (
                                        <Button
                                          color="success"
                                          size="sm"
                                          onClick={() =>
                                            entregarComissao(item.id)
                                          }
                                        >
                                          <FeatherIcon
                                            icon="check"
                                            className="me-1"
                                          />
                                          Entregar
                                        </Button>
                                      ) : (
                                        <Button
                                          color="secondary"
                                          size="sm"
                                          disabled
                                        >
                                          <FeatherIcon
                                            icon="check-circle"
                                            className="me-1"
                                          />
                                          Entregue
                                        </Button>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      <AwesomePagination
                        pagina={pagina}
                        totalPaginas={totalPaginas}
                        setPagina={(p) => {
                          setPagina(p);
                          setShouldFetch(true);
                        }}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Comissoes;
